
import { defineComponent } from "vue";
import mixin from "../../mixin";
import Button from "@/components/controls/ButtonControl.vue";
// import OTP from "../../components/controls/TextBoxField.vue";
import Modal from "@/components/controls/ModalControl.vue";
// import Prompt from "../../components/controls/Prompt.vue";
import Election from "@/services/Election";
import Loading from "@/components/controls/LoadingControl.vue";
import VOtpInput from "vue3-otp-input";
export default defineComponent({
    components: {
        Button,
        Loading,
        Modal,
        VOtpInput
        // OTP,
        // Prompt,
    },
    mixins: [
        mixin,
    ],
    data() {
        return {
            disabled: false,
            otp: '',
            uuid: '',
            email: '',
            mobile: '',
            username: null,
            sending: false,
            reset: false,
            prompt: false,
            loading:false,
            alert: {
                title: 'Error',
                message: 'Something went wrong.',
                show: false,
            },
            resending: false,
        }
    },
    mounted() {
        // this.getUserData();
        // this.checkIfStarted();
    },
    methods: {
        checkIfStarted() {
            const store = this.$store as any;
            const state = store.state;

            if(state.user.voted)
            {
                this.$router.push('/dashboard');
            }
        },
        closed() {
            this.prompt = false;
        },
        closedPrompt() {
            this.alert.show = false;
        },
        getUserData() {
            const store = this.$store as any;
            const state = store.state;

            this.uuid = state.user.uuid;
            this.email = state.user.email;
            this.mobile = state.user.mobile;
            this.username = state.user.username;
        },
        completed(val : any) {
            this.otp = val;
        },
        resetOTP() {
            this.reset = true;
        },
        verifyOTP() {
            const that = this;
           
            if(!this.sending)
            {
                this.sending = true;
                this.$emit('showloader');

                Election.verify(this.uuid, this.otp)
                    .then(function() {
                        that.$emit('hideloader');
                        that.sending = false;
                        that.$router.push('/election/voting');
                    })
                    .catch(function(error) {
                        let data = error.response.data;

                        that.$emit('hideloader');
                        that.sending = false;
                        that.error(data.message);
                        that.reset = true;
                    });
            }
        },
        error(message : string)
        {
            this.alert.message = message;
            this.alert.show = true;
        },
        resend() {
            this.prompt = true;
        },
        send() {
            const that = this;

            if(!this.resending)
            {
                this.resending = true;
                this.$emit('showloader');

                Election.resend(this.uuid)
                    .then(function() {
                        that.$emit('hideloader');
                        that.resending = false;
                    })
                    .catch(function(error) {
                        let data = error.response.data;

                        that.$emit('hideloader');
                        that.resending = false;
                        that.error(data.message);
                    });
            }
        },
    }
})
